import Vue from 'vue';
import VueRouter from 'vue-router';
import LandingScreen from '../views/LandingPage.vue';
import CarRecommender from '../views/CarRecommender.vue';
import RoutePlanner from '../views/RoutePlanner.vue';
import RoadTrips from '../views/RoadTrips.vue';
import DealerAdmin from '../views/DealerAdmin.vue';
import SignupForm from '../views/SignupForm.vue';
import LandingPageAppBar from '../appbars/LandingPageAppBar.vue';
import RoutePlannerAppBar from '../appbars/RoutePlannerAppBar.vue';
import RoadTripAppBar from '../appbars/RoadTripAppBar';
import CarRecommenderAppBar from '../appbars/CarRecommenderAppBar.vue';
import DealerAppBar from '../appbars/DealerAppBar.vue';
import NewAccount from '../views/NewAccount.vue';
import UserLogin from '../views/UserLogin.vue';
import DealerMenu from '../appbars/DealerMenu.vue';
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    components:
    {
      default: LandingScreen,
      navigation: LandingPageAppBar
    }
  },
  {
    path: '/recommender/:id',
    name: 'Recommender',
    components: {
      default:CarRecommender,
      navigation:CarRecommenderAppBar
    }
  },
  {
    path: '/planner',
    name: "Planner",
    components:
    {
      default: RoutePlanner,
      navigation: RoutePlannerAppBar
    }
  },
  {
    path: '/road-trips',
    name: "Road Trips",
    components: {
      default: RoadTrips,
      navigation: RoadTripAppBar
    }
  },
  {
    path: '/dealer',
    name: "Dealer",
    components: {
      default: DealerAdmin,
      navigation: DealerAppBar,
      menu: DealerMenu
    }
  },
  {
    path: '/signup',
    name: "SignUp",
    component: SignupForm
  },
  {
    path: '/new',
    name: "NewAccount",
    component: NewAccount
  },
  {
    path: '/login',
    name: "UserLogin",
    component: UserLogin
  }
];
const basename = function () {
  if (window.location.pathname.includes("dealer")) {
    return window.location.pathname.replace("/dealer", "");
  }
  if (window.location.pathname.includes("signup")) {
    return window.location.pathname.replace("/signup", "");
  }
  return window.location.pathname;
}();
const router = new VueRouter({
  //mode: 'history',
  //base: process.env.BASE_URL,
  base: basename,
  routes
});

export default router;
